export default "__VITE_ASSET__WEzlAuAz__"